<ng-template #customContent>
  @if (widget.levelAllergy) {
    <div class="order-3 w-full">
      <mat-chip
        [disableRipple]="true"
        [ngClass]="getChipsClass(widget.levelAllergy)"
        [attr.aria-label]="'ALLERGIE.' + widget.levelAllergy | translate"
      >
        {{ 'ALLERGIE.' + widget.levelAllergy | translate }}
      </mat-chip>
    </div>
  }
</ng-template>

<div class="table-widget-container">
  @if (tableRows().length > 0) {
    <siat-table
      [column]="tableColumns"
      [rows]="tableRows()"
      [hideLastColumnBorder]="true"
      [labelAria]="widget.title | translate"
      [titleClass]="'text-base'"
      [actionType]="actionType"
      [actionLabel]="actionLabelWithCount"
      [hideHeaderMarginTop]="true"
      [widgetId]="widget.id"
      [title]="widget.headerConfig ? '' : (widget?.title | translate)"
      (onClickAction)="onClickAction.emit()"
      [customContent]="customContent"
    >
      @if (labels.length > 0) {
        <ng-template siatTableCell="dataEffettiva" let-row>
          <span class="text-sm">
            {{
              row.dataEffettiva
                ? (row.dataEffettiva | date: 'dd/MM/yyyy - HH:mm')
                : '—'
            }}
          </span>
        </ng-template>
        <ng-template siatTableCell="contattoTelefonico" let-row>
          @if (
            row.prestazioneWorkflow?.contattoTelefonico ||
            row.prestazionePIC?.contattoTelefonico
          ) {
            <button
              mat-icon-button
              [attr.aria-label]="
                'PRESTAZIONI_SANITARIO.contatto_telefonico' | translate
              "
              [matTooltip]="
                'PRESTAZIONI_SANITARIO.contatto_telefonico' | translate
              "
              (click)="openContatti(row)"
            >
              <mat-icon class="material-icons-outlined">phone_enabled</mat-icon>
            </button>
          }
        </ng-template>
        @if (widget.id === WidgetID.SCALEPAZIENTE) {
          <ng-template
            [siatTableCell]="'risultato'"
            let-row
            class="text-center"
          >
            @let risultati = getUltimoRisultato(row);

            @if (risultati && risultati.length > 0) {
              <button
                [disabled]="lockedPatient"
                matButton="outlined"
                size="small"
                [matMenuTriggerFor]="detailMenu"
              >
                <mat-icon>analytics</mat-icon>
                <span class="ml-1 text-xs"
                  >Vedi risultati ({{ risultati.length }})</span
                >
              </button>

              <mat-menu #detailMenu="matMenu" xPosition="before">
                <div class="p-4 w-72">
                  <header class="flex items-center gap-2 mb-3 border-b pb-2">
                    <mat-icon class="text-primary">assignment</mat-icon>
                    <h4 class="font-bold text-sm m-0">
                      Ultimi Risultati Calcolati
                    </h4>
                  </header>

                  <div class="flex flex-col gap-3">
                    @for (item of risultati; track item.label) {
                      <div class="result-item">
                        <p
                          class="text-[10px] uppercase font-bold text-gray-400 leading-tight m-0"
                        >
                          {{ item.label }}
                        </p>
                        <p class="text-sm font-medium text-gray-800 m-0">
                          {{ item.value }}
                        </p>
                      </div>
                    }
                  </div>
                </div>
              </mat-menu>
            } @else {
              <span class="text-gray-300 text-xs italic">Nessun dato</span>
            }
          </ng-template>
        }
        @if (widget.id !== WidgetID.ALLERGIE) {
          <ng-template [siatTableCell]="labels[0]" let-row>
            <div>
              @if (hasDetails()) {
                @if (hasFeaturePermission(widget?.config?.path?.permission)) {
                  <a
                    [disabled]="lockedPatient"
                    class="underline!"
                    matButton
                    tabindex="0"
                    role="button"
                    (click)="onLinkClick(row)"
                  >
                    @if (row?.alert === true) {
                      <mat-icon
                        class="text-on-secondary-container! material-icons-outlined"
                        [matTooltip]="getAlertMessage()"
                        >warning</mat-icon
                      >
                    }
                    {{ getFirstCellValue(row) }}
                  </a>
                } @else {
                  @if (row?.alert === true) {
                    <mat-icon
                      class="text-on-secondary-container! material-icons-outlined"
                      [matTooltip]="getAlertMessage()"
                      >warning</mat-icon
                    >
                  }
                  {{ getFirstCellValue(row) }}
                }
              } @else {
                @if (row?.alert === true) {
                  <mat-icon
                    class="text-on-secondary-container! material-icons-outlined"
                    [matTooltip]="getAlertMessage()"
                    >warning</mat-icon
                  >
                }
                {{ getFirstCellValue(row) }}
              }
            </div>
          </ng-template>
        }
        @if (widget.id === WidgetID.ALLERGIE) {
          <ng-template siatTableCell="nome" let-row>
            <p class="m-0">{{ row.nomeAltro || row.nome || '—' }}</p>
          </ng-template>
          <ng-template [siatTableCell]="labels[labels.length - 1]" let-row>
            <div
              class="text-left flex justify-start items-center space-x-2 actions-btn"
            >
              @if (hasDeletePermission) {
                <button
                  [disabled]="lockedPatient"
                  mat-icon-button
                  [attr.aria-label]="
                    'CRUD.actions.delete_allergia'
                      | translate: { item: row.nome }
                  "
                  (click)="action(row)"
                >
                  <mat-icon class="material-icons-outlined">delete</mat-icon>
                </button>
              }
              @if (hasUpdatePermission && row.tipo !== 'Nessuna') {
                <button
                  [disabled]="lockedPatient"
                  mat-icon-button
                  [attr.aria-label]="
                    'CRUD.actions.edit_allergia' | translate: { item: row.nome }
                  "
                  (click)="updateAllergiaInt(row)"
                >
                  <mat-icon class="material-icons-outlined">edit</mat-icon>
                </button>
              }
            </div>
          </ng-template>
        }
        @if (widget.id === WidgetID.PIC) {
          <ng-template [siatTableCell]="labels[labels.length - 1]" let-row>
            @if (hasReadPermission) {
              <div
                class="text-left flex justify-start items-center space-x-2 actions-btn"
              >
                <button
                  [disabled]="lockedPatient"
                  mat-icon-button
                  [attr.aria-label]="
                    'CRUD.actions.edit' | translate: { item: 'pic' }
                  "
                  (click)="action(row)"
                >
                  <mat-icon class="material-icons-outlined">edit</mat-icon>
                </button>
              </div>
            }
          </ng-template>
        }
        @if (widget.id === '68d6ace5f0a4523c76e296f9') {
          <ng-template [siatTableCell]="'nomeSegnalazione'" let-row>
            <div class="flex items-center gap-2">
              <a
                class="underline! cursor-pointer inline"
                matButton
                tabindex="0"
                role="button"
                [attr.ariaLabel]="
                  row.nomeSegnalazione +
                  '-' +
                  row.paziente?.nome +
                  ' ' +
                  row.paziente?.cognome
                "
                (click)="editBozza.emit(row)"
                (keydown.enter)="editBozza.emit(row)"
                (keydown.space)="editBozza.emit(row)"
              >
                {{ row.nomeSegnalazione || '—' }}
              </a>
              @if (row?.prosecuzione === true) {
                <mat-chip class="blue-chips shrink-0">PROS</mat-chip>
              }
            </div>
          </ng-template>
        }
        @if (widget.id === '68cad3ba284e595e74febc26') {
          <ng-template [siatTableCell]="'nomeSegnalazione'" let-row>
            <div class="flex items-center gap-2">
              <a
                class="underline! cursor-pointer inline"
                matButton
                tabindex="0"
                role="button"
                [attr.ariaLabel]="
                  row.nomeSegnalazione +
                  '-' +
                  row.paziente?.nome +
                  ' ' +
                  row.paziente?.cognome
                "
                (click)="goToDetailSegnalazioni.emit(row)"
                (keydown.enter)="goToDetailSegnalazioni.emit(row)"
                (keydown.space)="goToDetailSegnalazioni.emit(row)"
              >
                {{ row.nomeSegnalazione || '—' }}
              </a>
              @if (row?.prosecuzione === true) {
                <mat-chip class="blue-chips shrink-0">PROS</mat-chip>
              }

              @if (row?.giorniScaduta > 0) {
                <mat-chip class="scaduta-chips">
                  <span class="inline-flex items-center">
                    <mat-icon class="w-4! h-4! text-base! leading-none! mr-2"
                      >schedule</mat-icon
                    >
                    <span>Scaduto da {{ row?.giorniScaduta }} gg</span>
                  </span>
                </mat-chip>
              }
            </div>
          </ng-template>
          <ng-template [siatTableCell]="'paziente.nome'" let-row>
            @if (row.workflow.multipaziente) {
              @let expanded = isRowExpanded(row.id);
              @let patients =
                expanded
                  ? row.listaPazientiAssociati
                  : row.listaPazientiAssociati.slice(0, MAX_VISIBLE_PATIENTS);

              @for (patient of patients; track $index) {
                <div class="py-0.5">{{ patient?.nome || '-' }}</div>
              }

              @if (row.listaPazientiAssociati.length > MAX_VISIBLE_PATIENTS) {
                <button
                  mat-button
                  class="text-xs! p-0! min-w-0! h-auto! leading-tight! m-1"
                  (click)="$event.stopPropagation(); expandRow(row.id)"
                >
                  {{
                    expanded
                      ? ('GENERAL.mostra_meno' | translate)
                      : '+ altri ' +
                        (row.listaPazientiAssociati.length -
                          MAX_VISIBLE_PATIENTS)
                  }}
                </button>
              }
            } @else {
              {{ row.paziente?.nome || '—' }}
            }
          </ng-template>
          <ng-template [siatTableCell]="'paziente.codiceFiscale'" let-row>
            @if (row.workflow.multipaziente) {
              @let expanded = isRowExpanded(row.id);
              @let patients =
                expanded
                  ? row.listaPazientiAssociati
                  : row.listaPazientiAssociati.slice(0, MAX_VISIBLE_PATIENTS);

              @for (patient of patients; track $index) {
                <div class="py-0.5">{{ patient?.codiceFiscale || '-' }}</div>
              }

              @if (row.listaPazientiAssociati.length > MAX_VISIBLE_PATIENTS) {
                <button
                  mat-button
                  class="text-xs! p-0! min-w-0! h-auto! leading-tight! m-1"
                  (click)="$event.stopPropagation(); expandRow(row.id)"
                >
                  {{
                    expanded
                      ? ('GENERAL.mostra_meno' | translate)
                      : '+ altri ' +
                        (row.listaPazientiAssociati.length -
                          MAX_VISIBLE_PATIENTS)
                  }}
                </button>
              }
            } @else {
              {{ row.paziente?.codiceFiscale || '—' }}
            }
          </ng-template>
          <ng-template [siatTableCell]="'paziente.cognome'" let-row>
            @if (row.workflow.multipaziente) {
              @let expanded = isRowExpanded(row.id);
              @let patients =
                expanded
                  ? row.listaPazientiAssociati
                  : row.listaPazientiAssociati.slice(0, MAX_VISIBLE_PATIENTS);

              @for (patient of patients; track $index) {
                <div class="py-0.5">{{ patient?.cognome || '-' }}</div>
              }

              @if (row.listaPazientiAssociati.length > MAX_VISIBLE_PATIENTS) {
                <button
                  mat-button
                  class="text-xs! p-0! min-w-0! h-auto! leading-tight! m-1"
                  (click)="$event.stopPropagation(); expandRow(row.id)"
                >
                  {{
                    expanded
                      ? ('GENERAL.mostra_meno' | translate)
                      : '+ altri ' +
                        (row.listaPazientiAssociati.length -
                          MAX_VISIBLE_PATIENTS)
                  }}
                </button>
              }
            } @else {
              {{ row.paziente?.cognome || '—' }}
            }
          </ng-template>
        }

        @if (widget.id === WidgetID.SEGNALAZIONI) {
          <ng-template [siatTableCell]="labels[labels.length - 1]" let-row>
            @if (hasReadPermission) {
              <div
                class="text-left flex justify-start items-center space-x-2 actions-btn"
              >
                @let btnState = getSegnalazioneActionState(row);
                @let notaState = getNotaSegnalazioneActionState(row);
                <button
                  [disabled]="lockedPatient"
                  mat-icon-button
                  [attr.aria-label]="btnState.tooltip"
                  (click)="action(row)"
                >
                  <mat-icon
                    class="material-icons-outlined"
                    fontIcon="visibility"
                  ></mat-icon>
                </button>
                @if (!notaState.disabled) {
                  <button
                    mat-icon-button
                    [disabled]="notaState.disabled || lockedPatient"
                    [attr.aria-label]="'SEGNALAZIONE.aggiungi_nota' | translate"
                    (click)="addNota(row)"
                  >
                    <mat-icon
                      class="material-icons-outlined"
                      fontIcon="edit"
                    ></mat-icon>
                  </button>
                }
              </div>
            }
          </ng-template>
        }
        @if (widget.id === WidgetID.CASEMANAGER) {
          <ng-template [siatTableCell]="'cognomeCaseManager'" let-row>
            {{ row.cognomeCaseManager }} {{ row.nomeCaseManager }}
          </ng-template>
          <ng-template [siatTableCell]="'cognomeReferenteClinico'" let-row>
            {{ row.cognomeReferenteClinico }} {{ row.nomeReferenteClinico }}
          </ng-template>
          <ng-template [siatTableCell]="labels[labels.length - 1]" let-row>
            <div
              class="text-left flex justify-start items-center space-x-2 actions-btn"
            >
              <button
                [disabled]="lockedPatient"
                mat-icon-button
                [attr.aria-label]="
                  'CRUD.actions.edit' | translate: { item: 'caseManager' }
                "
                (click)="action(row)"
              >
                <mat-icon class="material-icons-outlined">edit</mat-icon>
              </button>
            </div>
          </ng-template>
        }
        @if (widget.id === WidgetID.PAI) {
          <ng-template siatTableCell="moduliPai" let-row>
            {{ getPaiModuli(row) }}
          </ng-template>
        }
        @if (widget.id === WidgetID.PDC || widget.id === WidgetID.PAI) {
          <ng-template [siatTableCell]="labels[labels.length - 1]" let-row>
            @if (hasReadPermission) {
              <div
                class="text-left flex justify-start items-center space-x-2 actions-btn"
              >
                @let btnState = getSegnalazioneActionState(row);

                <button
                  mat-icon-button
                  [disabled]="btnState.disabled || lockedPatient"
                  [attr.aria-label]="btnState.tooltip"
                  (click)="action(row)"
                >
                  <mat-icon class="material-icons-outlined"
                    >visibility</mat-icon
                  >
                </button>
                @if (
                  widget.id === WidgetID.PAI && canRequestPaiAssociation(row)
                ) {
                  <button
                    mat-icon-button
                    [disabled]="lockedPatient"
                    [attr.aria-label]="'Richiedi associazione PAI'"
                    [matTooltip]="'Richiedi associazione PAI'"
                    (click)="requestPaiAssociation(row)"
                  >
                    <mat-icon class="material-icons-outlined"
                      >add_link</mat-icon
                    >
                  </button>
                }
              </div>
            }
          </ng-template>
        }

        @if (
          widget.id === WidgetID.ANAMNESI || widget.id === WidgetID.TERAPIA
        ) {
          <ng-template [siatTableCell]="labels[labels.length - 1]" let-row>
            @if (hasReadPermission) {
              <div
                class="text-left flex justify-start items-center space-x-2 actions-btn"
              >
                <button
                  [disabled]="lockedPatient"
                  mat-icon-button
                  [attr.aria-label]="'Dettaglio ' + widget.id"
                  [matTooltip]="'Dettaglio ' + widget.id"
                  (click)="action(row)"
                >
                  <mat-icon
                    class="material-icons-outlined"
                    fontIcon="visibility"
                  ></mat-icon>
                </button>
                @if (widget.id === WidgetID.TERAPIA) {
                  @if (row?.stato === 'ATTIVA') {
                    <button
                      [disabled]="lockedPatient"
                      mat-icon-button
                      [attr.aria-label]="'Sospendi terapia'"
                      [matTooltip]="'Sospendi terapia'"
                      (click)="sospendiTerapia(row)"
                    >
                      <mat-icon
                        class="material-icons-outlined"
                        fontIcon="pause_circle"
                      ></mat-icon>
                    </button>
                  }
                  @if (row?.stato === 'SOSPESA') {
                    <button
                      [disabled]="lockedPatient"
                      mat-icon-button
                      [attr.aria-label]="'Riattiva terapia'"
                      [matTooltip]="'Riattiva terapia'"
                      (click)="riattivaTerapia(row)"
                    >
                      <mat-icon
                        class="material-icons-outlined"
                        fontIcon="play_circle"
                      ></mat-icon>
                    </button>
                  }
                  @if (row?.stato !== 'TERMINATA') {
                    <button
                      [disabled]="lockedPatient"
                      mat-icon-button
                      [attr.aria-label]="'Termina terapia'"
                      [matTooltip]="'Termina terapia'"
                      (click)="terminaTerapia(row)"
                    >
                      <mat-icon
                        class="material-icons-outlined"
                        fontIcon="stop_circle"
                      ></mat-icon>
                    </button>
                  }
                  @if (row?.stato !== 'TERMINATA') {
                    <button
                      [disabled]="lockedPatient"
                      mat-icon-button
                      [attr.aria-label]="'Somministrazioni'"
                      [matTooltip]="'Somministrazioni'"
                      (click)="addSomministrazione(row)"
                    >
                      <mat-icon
                        class="material-icons-outlined"
                        fontIcon="vaccines"
                      ></mat-icon>
                    </button>
                  }
                  <button
                    mat-icon-button
                    [attr.aria-label]="'Storico'"
                    [matTooltip]="'Storico'"
                    (click)="openStoricoTerapia(row)"
                  >
                    <mat-icon
                      class="material-icons-outlined"
                      fontIcon="history"
                    ></mat-icon>
                  </button>
                }
              </div>
            }
          </ng-template>
        }

        @if (widget.id === WidgetID.PRESCRIZIONI) {
          <ng-template [siatTableCell]="labels[labels.length - 1]" let-row>
            @if (hasReadPermission) {
              <div
                class="text-left flex justify-start items-center space-x-2 actions-btn"
              >
                <button
                  [disabled]="lockedPatient"
                  mat-icon-button
                  [attr.aria-label]="'Dettaglio ' + widget.id"
                  [matTooltip]="'Dettaglio ' + widget.id"
                  (click)="action(row)"
                >
                  <mat-icon class="material-icons-outlined"
                    >visibility</mat-icon
                  >
                </button>
              </div>
            }
          </ng-template>
        }

        @if (widget.id === WidgetID.TRASFERIMENTO_APIC) {
          <ng-template siatTableCell="periodo" let-row>
            <span class="text-sm"
              >{{ row.dataDa | date: 'dd/MM/yyyy' }} -
              {{ row.dataA | date: 'dd/MM/yyyy' }}</span
            >
          </ng-template>
          <ng-template siatTableCell="statoApic" let-row>
            <span
              class="status-badge"
              [ngClass]="'status-apic-' + getApicStato(row).toLowerCase()"
              role="status"
              [attr.aria-label]="getApicStatoLabel(row)"
            >
              {{ getApicStatoLabel(row) }}
            </span>
          </ng-template>
          <ng-template siatTableCell="actions" let-row>
            <div class="flex gap-2 actions-btn">
              @if (hasReadPermission) {
                <button
                  [disabled]="lockedPatient"
                  mat-icon-button
                  [attr.aria-label]="
                    'TRASFERIMENTO.apri_foglio_presenze' | translate
                  "
                  [matTooltip]="
                    'TRASFERIMENTO.apri_foglio_presenze' | translate
                  "
                  (click)="openFoglioPresenzeApic(row)"
                >
                  <mat-icon class="material-icons-outlined"
                    >visibility</mat-icon
                  >
                </button>
              }
              @if (
                hasUpdatePermission &&
                isApicEditable(row) &&
                canManageApicTransfer(row)
              ) {
                <button
                  [disabled]="lockedPatient"
                  mat-icon-button
                  [attr.aria-label]="'TRASFERIMENTO.edit_periodo' | translate"
                  [matTooltip]="'TRASFERIMENTO.edit_periodo' | translate"
                  (click)="action(row)"
                >
                  <mat-icon class="material-icons-outlined">edit</mat-icon>
                </button>
              }
              @if (
                hasDeletePermission &&
                isApicEditable(row) &&
                canManageApicTransfer(row)
              ) {
                <button
                  [disabled]="lockedPatient"
                  mat-icon-button
                  [attr.aria-label]="
                    'TRASFERIMENTO.elimina_schedulazione' | translate
                  "
                  [matTooltip]="
                    'TRASFERIMENTO.elimina_schedulazione' | translate
                  "
                  (click)="action(row, true)"
                >
                  <mat-icon class="material-icons-outlined">delete</mat-icon>
                </button>
              }
            </div>
          </ng-template>
        }

        @if (widget.id === dashboardWidgetIdEum.prestazioni_in_corso) {
          <ng-template siatTableCell="nomePrestazione" let-row>
            <span class="inline-flex items-center gap-1">
              @if (row?.prestazioneWorkflow?.aDomicilio) {
                <mat-icon
                  class="material-icons-outlined shrink-0 text-[1.4em] h-[1.4em] w-[1.4em] leading-none"
                  matTooltip="Prestazione a domicilio"
                  >home_work</mat-icon
                >
              } @else {
                <mat-icon
                  class="material-icons-outlined shrink-0 text-[1.4em] h-[1.4em] w-[1.4em] leading-none"
                  matTooltip="Prestazione in struttura"
                  >apartment</mat-icon
                >
              }
              <span class="inline-flex shrink-0 w-[1.4em] mr-1">
                @if (row?.idPrestazionePrincipale) {
                  <mat-icon
                    class="material-icons-outlined shrink-0 text-[1.4em] h-[1.4em] w-[1.4em] leading-none"
                    matTooltip="Prestazione collegata"
                    >link</mat-icon
                  >
                }
              </span>
              @if (
                hasDetails() &&
                hasFeaturePermission(widget?.config?.path?.permission)
              ) {
                <a
                  [disabled]="lockedPatient"
                  class="underline!"
                  matButton
                  tabindex="0"
                  role="button"
                  (click)="onLinkClick(row, true)"
                >
                  {{ (row.nomePrestazione | titlecase) || '—' }}
                </a>
              } @else {
                {{ (row.nomePrestazione | titlecase) || '—' }}
              }
            </span>
          </ng-template>
          <ng-template siatTableCell="contattoTelefonico" let-row>
            @if (
              row.prestazioneWorkflow?.contattoTelefonico ||
              row.prestazionePIC?.contattoTelefonico
            ) {
              <button
                mat-icon-button
                [attr.aria-label]="
                  'PRESTAZIONI_SANITARIO.contatto_telefonico' | translate
                "
                [matTooltip]="
                  'PRESTAZIONI_SANITARIO.contatto_telefonico' | translate
                "
                (click)="openContatti(row)"
              >
                <mat-icon class="material-icons-outlined"
                  >phone_enabled</mat-icon
                >
              </button>
            }
          </ng-template>
        }
        @if (widget.id === WidgetID.PRESCRIZIONI) {
          <ng-template siatTableCell="descProdotto" let-row>
            <p class="m-0">{{ row?.dettagliPrescrizione[0]?.descProdotto }}</p>
          </ng-template>
        }
        @if (widget.id === WidgetID.DOCUMENTI_DSE) {
          <ng-template [siatTableCell]="'datoMaggiorTutelaAnonimato'" let-row>
            @let tutela =
              getTutelaAnonimatoInfo(row.datoMaggiorTutelaAnonimato);
            <div class="inline-flex items-center justify-center w-10 h-10">
              <mat-icon
                class="material-icons-outlined"
                [ngClass]="tutela.colorClass"
                [matTooltip]="tutela.labelKey | translate"
                matTooltipPosition="above"
                >{{ tutela.icon }}</mat-icon
              >
            </div>
          </ng-template>
          <ng-template [siatTableCell]="'vediDettagli'" let-row>
            <div
              class="text-left flex justify-start items-center space-x-2 actions-btn"
            >
              <button
                [disabled]="lockedPatient"
                mat-icon-button
                [attr.aria-label]="'Dettaglio documento DSE/FSE'"
                (click)="action(row)"
              >
                <mat-icon
                  class="material-icons-outlined"
                  fontIcon="visibility"
                ></mat-icon>
              </button>
            </div>
          </ng-template>
        }
        @if (widget.id === WidgetID.REFERENTI) {
          <ng-template siatTableCell="nome" let-row>
            <p class="m-0">
              {{ ((row.nome ?? '') + ' ' + (row.cognome ?? '')).trim() || '—' }}
            </p>
          </ng-template>
          <ng-template siatTableCell="contatti" let-row>
            @let contatti = row.contattiConTipo ?? [];
            @let expanded = isContattiExpanded(row);
            <div class="flex flex-col gap-1 py-1">
              @for (
                contatto of expanded
                  ? contatti
                  : contatti.slice(0, maxContattiVisibili);
                track $index
              ) {
                <div class="flex items-center gap-2">
                  <mat-icon
                    class="material-icons-outlined shrink-0 text-base! w-4! h-4! leading-4! text-neutral-500"
                    [matTooltip]="contatto.tipo"
                    aria-hidden="true"
                    >{{ contatto.icon }}</mat-icon
                  >
                  <span class="sr-only">{{ contatto.tipo }}:</span>
                  <span class="break-all">{{ contatto.contatto }}</span>
                </div>
              } @empty {
                <p class="m-0">—</p>
              }
              @if (contatti.length > maxContattiVisibili) {
                <button
                  type="button"
                  class="self-start p-0 border-0 bg-transparent cursor-pointer text-sm font-medium text-primary hover:underline"
                  [attr.aria-expanded]="expanded"
                  (click)="toggleContatti(row, $event)"
                >
                  {{
                    expanded
                      ? ('REFERENTI.mostra_meno_contatti' | translate)
                      : ((contatti.length - maxContattiVisibili === 1
                          ? 'REFERENTI.altro_contatto'
                          : 'REFERENTI.altri_contatti'
                        )
                        | translate
                          : { count: contatti.length - maxContattiVisibili })
                  }}
                </button>
              }
            </div>
          </ng-template>
          <ng-template siatTableCell="caregiver" let-row>
            @let caregiverLocked =
              lockedPatient || row.sistema !== 'SIAT' || !hasUpdatePermission;
            <mat-slide-toggle
              (click)="!caregiverLocked && setSwitchData(row)"
              [name]="'caregiver' + row.id"
              [checked]="row.caregiver"
              [formControl]="
                createFormControl(
                  'caregiver' + row.id,
                  row.caregiver,
                  caregiverLocked
                )
              "
              aria-label="Caregiver"
            ></mat-slide-toggle>
          </ng-template>
          <ng-template siatTableCell="actions" let-row>
            <div
              class="text-left flex justify-start items-center space-x-2 actions-btn"
            >
              @if (row.sistema === 'SIAT' && hasUpdatePermission) {
                <button
                  [disabled]="lockedPatient"
                  mat-icon-button
                  [attr.aria-label]="'Modifica referente'"
                  (click)="action(row, 'edit')"
                >
                  <mat-icon class="material-icons-outlined">edit</mat-icon>
                </button>
              }
              @if (row.sistema === 'SIAT' && hasDeletePermission) {
                <button
                  [disabled]="lockedPatient"
                  mat-icon-button
                  [attr.aria-label]="
                    'CRUD.actions.delete_referente'
                      | translate: { item: row.nome }
                  "
                  (click)="action(row, 'delete')"
                >
                  <mat-icon class="material-icons-outlined">delete</mat-icon>
                </button>
              }
            </div>
          </ng-template>
        }
        @if (widget.id === WidgetID.NOTE) {
          <ng-template siatTableCell="statoNota" let-row>
            <mat-chip
              class="status-badge"
              [class.magenta-chips]="row.statoNota === 'in corso'"
              [class.blue-chips]="row.statoNota === 'chiuso'"
              [attr.aria-label]="row.statoNota | translate"
              >{{ row.statoNota }}</mat-chip
            >
          </ng-template>
          <ng-template siatTableCell="actions" let-row>
            <div
              class="text-left flex justify-start items-center space-x-2 actions-btn"
            >
              @if (hasUpdatePermission) {
                <button
                  [disabled]="lockedPatient"
                  matIconButton
                  [attr.aria-label]="'CRUD.actions.change_state' | translate"
                  (click)="action(row)"
                >
                  <mat-icon class="material-icons-outlined m-0!"
                    >sync_alt</mat-icon
                  >
                </button>
              }
            </div>
          </ng-template>
        }
        @if (widget.id === WidgetID.DOCUMENTI) {
          <ng-template [siatTableCell]="labels[labels.length - 1]" let-row>
            @if (hasReadPermission) {
              <div
                class="text-left flex justify-start items-center space-x-2 actions-btn"
              >
                <button
                  [disabled]="lockedPatient"
                  mat-icon-button
                  [attr.aria-label]="
                    'CRUD.actions.view'
                      | translate: { item: 'DOCUMENTI.singular' | translate }
                  "
                  (click)="download(row)"
                >
                  <mat-icon class="material-icons-outlined">search</mat-icon>
                </button>
              </div>
            }
          </ng-template>
        }
        @if (widget.id === 'monitoraggio') {
          <ng-template siatTableCell="tipoParametro" let-data>
            {{ getMonitoraggioType(data.tipoParametro) }}
          </ng-template>
          <ng-template siatTableCell="misurazione" let-data>
            {{ addType(data) }}
          </ng-template>
        }
        @if (widget.id === WidgetID.NOTE) {
          <ng-template siatTableCell="sanitario" let-data>
            <p>
              {{
                data.sanitario?.cognome
                  ? data.sanitario.nome + ' ' + data.sanitario.cognome
                  : '-'
              }}
            </p>
          </ng-template>
        }
      }

      @for (statusColumn of statusColumns; track statusColumn) {
        <ng-template [siatTableCell]="statusColumn" let-row>
          @if (row[statusColumn]) {
            <span
              class="status-badge"
              [ngClass]="getStatusClass(row[statusColumn])"
              role="status"
              [attr.aria-label]="getStatusAriaLabel(row[statusColumn])"
            >
              {{ getStatusLabel(row[statusColumn]) }}
            </span>
          }
        </ng-template>
      }
      @for (typeColumn of typeColumns; track typeColumn) {
        <ng-template [siatTableCell]="typeColumn" let-row>
          {{ getDocumentoTypeLabel(row[typeColumn]) }}
        </ng-template>
      }
      @for (col of translateColumns; track col.key) {
        <ng-template [siatTableCell]="col.key" let-row>
          {{ row[col.key] | translateCell: col.prefix }}
        </ng-template>
      }
    </siat-table>
  } @else {
    @if (widget?.id === 'allergie' && widget?.levelAllergy === 'GIALLO') {
      <div class="flex items-center justify-center py-8 align-center">
        <span
          [matTooltip]="
            isApicActive
              ? 'Non è possibile eseguire l\'operazione in quanto il paziente è in trasferimento'
              : ''
          "
        >
          <button
            matButton="tonal"
            type="button"
            class="ms-4"
            (click)="setAllergieNote.emit()"
            [attr.aria-label]="'Imposta nessuna allergia dichiarata'"
            [matTooltip]="
              isApicActive ? '' : 'Imposta nessuna allergia dichiarata'
            "
            [disabled]="isApicActive"
          >
            Imposta nessuna allergia dichiarata
            <mat-icon
              class="material-icons-outlined"
              fontIcon="do_not_disturb_on"
            ></mat-icon>
          </button>
        </span>
      </div>
    } @else {
      @if (!widget?.headerConfig) {
        <h2 class="widget-name px-4 mb-0">{{ widget.title | translate }}</h2>
      }
      <div class="flex items-center justify-center py-8 align-ceneter">
        <p class="m-0 text-sm text-gray-500">
          {{ 'GENERAL.no_results_found' | translate }}
        </p>
      </div>
    }
  }
</div>
